import {
  AgentProfile,
  GuestProfile,
  Invitee,
  LimitedAgentProfile
} from "@closerplatform/spinner-openapi";

export type UserProfile = AgentProfile | LimitedAgentProfile | GuestProfile;

export const isAgentProfile = (profile: UserProfile): profile is AgentProfile =>
  profile && "isBot" in profile;

export const isActiveAgent = (agent: AgentProfile | Invitee): agent is AgentProfile =>
  (agent as AgentProfile).id !== undefined;

export const isGuestProfile = (profile: UserProfile): profile is GuestProfile =>
  profile && "roomId" in profile;

export const isBotProfile = (profile: UserProfile): profile is AgentProfile =>
  profile && isAgentProfile(profile) && profile.isBot;

export const equals = (profile1: UserProfile, profile2: UserProfile): boolean =>
  (isAgentProfile(profile1) ? isAgentProfile(profile2) : isGuestProfile(profile2)) &&
  profile1.id === profile2.id;

export const hasProfileMailOrPhone = (profile: GuestProfile | undefined): boolean =>
  (profile && (!!profile.email || !!profile.phone)) || false;
